export const ANIMATION_DURATION = 8000;
export const PASCAL_PLATFORM_ID = 18746949;
export const BET_SHOP_GAME_ID = 156140;
export const TURBO_GAME_ID = 44444;

export const ROULETTE_ROOM_NAMES = ['Black', 'White']

export const SOCKET_METHODS = {
    GetBalanceResult: 'GetBalanceResult',
    GetBalance: 'GetBalance',
};